<template>
  <app-popup-page>
    <div class="w-full h-full">
      <div class="relative flex flex-col w-full h-full">
        <section class="mb-4">
          <h1 class="text-center">
            <span
              class="text-primary text-title-sm md:text-title-md"
              v-text="`${page.titolo1} `"
            />
            <span
              class="text-title-sm md:text-title-md"
              v-text="`${page.titolo2}`"
            />
          </h1>
        </section>
        <section class="mb-4">
          <download-list v-bind="page" />
        </section>
      </div>
    </div>
  </app-popup-page>
</template>

<script>
import { axios } from "@/plugins/axios";
import DownloadList from "../../components/downloadList.vue";

export default {
  components: { DownloadList },
  props: { navigate: { default: null } },
  async beforeRouteEnter(to, from, next) {
    let page;
    try {
      page = await axios.get(`/pageContent${to.path}.json`);
    } catch (error) {
      page = {};
    } finally {
      next(vm => (vm.page = page.data));
    }
  }
};
</script>
<route>
{
  "name": "Privacy",
  "meta": {

  }
}
</route>
